import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { CardHeader, CardTitle } from "@/components/ui/card";
import { Bot, MessageCircle, MessageSquare, ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { Agent } from "@/types/agent";

interface Conversation {
  id: string;
  name: string;
  lastMessage: string;
  timestamp: string;
  unread?: boolean;
  source: 'telegram' | 'whatsapp';
}

interface ChatHeaderProps {
  selectedAgent: Agent | null;
  selectedConversation: Conversation | null;
  onBack?: () => void;
}

export const ChatHeader = ({ selectedAgent, selectedConversation, onBack }: ChatHeaderProps) => {
  if (!selectedAgent && !selectedConversation) return null;

  return (
    <CardHeader className="border-b border-gray-200 bg-white">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {onBack && (
            <Button variant="ghost" size="icon" onClick={onBack} className="mr-2">
              <ChevronLeft className="h-4 w-4" />
            </Button>
          )}
          {selectedConversation && (
            <>
              {selectedConversation.source === 'telegram' ? (
                <MessageCircle className="h-5 w-5 text-blue-500" />
              ) : (
                <MessageSquare className="h-5 w-5 text-green-500" />
              )}
              <CardTitle className="text-lg">
                {selectedConversation.name}
              </CardTitle>
            </>
          )}
        </div>
        
        {selectedAgent && (
          <div className="flex items-center gap-2">
            <span className="text-sm text-muted-foreground hidden md:inline">Agente ativo:</span>
            <Avatar className="w-8 h-8 border border-primary">
              <AvatarImage 
                src={selectedAgent.avatar} 
                alt={selectedAgent.name}
                className="object-cover"
              />
              <AvatarFallback className="bg-primary/10">
                <Bot className="h-4 w-4 text-primary" />
              </AvatarFallback>
            </Avatar>
            <span className="text-sm font-medium hidden md:inline">{selectedAgent.name}</span>
          </div>
        )}
      </div>
    </CardHeader>
  );
};